export default "__VITE_ASSET__d5d57664__"